// src/components/PrimaryTabs.jsx
"use client";

import { useEffect, useRef } from "react";

export default function PrimaryTabs({ tabs, active, onChange }) {
  const activeTabRef = useRef(null);

  useEffect(() => {
    activeTabRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "center",
    });
  }, [active]);

  return (
    <div className="w-full max-w-full overflow-hidden">
      <div className="mx-auto max-w-3xl min-w-0 px-4">
        <div className="tabs-scroll no-scrollbar -mx-4 px-4">
          <div className="flex w-max min-w-full items-center gap-1 py-2">
            {tabs.map((t) => {
              const is = t.key === active;
              return (
                <button
                  key={t.key}
                  ref={is ? activeTabRef : null}
                  aria-pressed={is}
                  onClick={() => onChange?.(t.key)}
                  className={[
                    "relative shrink-0 whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium outline-none",
                    "focus-visible:ring-2 focus-visible:ring-offset-0 focus-visible:ring-[var(--brand)]",
                    is
                      ? "text-[var(--brand)]"
                      : "text-[var(--muted)] hover:text-[var(--foreground)]",
                  ].join(" ")}
                >
                  {t.label}
                  {/* Underline indicator */}
                  <span
                    aria-hidden
                    className={[
                      "absolute left-2 right-2 -bottom-[7px] h-[2px] rounded",
                      is ? "bg-[var(--brand)]" : "bg-transparent",
                    ].join(" ")}
                  />
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
